import React from 'react';
import styled from 'styled-components';

const TutorialButtonWrapper = styled.div`
  ${props => props.$fixed ? `
    position: fixed;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    display: flex;
    justify-content: center;
    width: 100%;
    pointer-events: none;
    
    @media (max-width: 768px) {
      bottom: 0.75rem;
    }
  ` : `
    margin-top: 1rem;
  `}
`;

const StyledTutorialButton = styled.button`
  padding: 0.7rem 1.5rem;
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 0.8rem;
  font-weight: 700;
  border: 2px solid rgba(255,255,255,0.2);
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  position: relative;
  overflow: hidden;
  background: transparent;
  ${props => props.$fixed ? 'pointer-events: all;' : ''}
  
  /* Button background */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255,255,255,0.49);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 13px;
    z-index: 0;
  }
  
  /* Gradient text effect */
  span {
    position: relative;
    z-index: 1;
    background: linear-gradient(45deg, #FF3366, #FF6B35, #FFD23F, #06FFA5);
    background-size: 300% 300%;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: shine 3s ease-in-out infinite;
    display: inline-block;
  }
  
  @keyframes shine {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
  }
  
  &:hover {
    transform: scale(1.05);
    &::before {
      background: rgba(255,255,255,0.08);
    }
  }
  
  &:active {
    transform: scale(0.98);
  }
  
  @media (max-width: 768px) {
    font-size: ${props => props.$fixed ? '0.75rem' : '0.8rem'};
    padding: ${props => props.$fixed ? '0.6rem 1.2rem' : '0.7rem 1.5rem'};
  }
`;

const TutorialButton = ({ onClick, theme, fixed = false, children = 'HOW TO PLAY' }) => {
  return (
    <TutorialButtonWrapper $fixed={fixed} theme={theme}>
      <StyledTutorialButton onClick={onClick} theme={theme} $fixed={fixed}>
        <span>{children}</span>
      </StyledTutorialButton>
    </TutorialButtonWrapper>
  );
};

export default TutorialButton;

